module.exports = __webpack_public_path__ + "static/media/click_image.a6a4652c.png";